import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/react-wrap-balancer/dist/index.mjs");
